module dg.lists {


    export interface IChartOptions extends dg.actions.ICompositeDisplayerOptions {
        type?: 'chart';
    }

    export class ChartService {
        
        constructor() {

        }

        public static getChartOptions(options?: IChartOptions): IChartOptions {
            let result = dgUtils.ObjectHelperService.mergeDeep({
                type: 'chart',
                templateUrl: '/digmo/src/actions/list-query/list-query',
                displayValue: 'Chart'
            }, options);
            return result;
        }


        public getItemByIndex(data, items, itemPlaceholders) {
            let xItemIndex;

            var infoText = data.points.map((d) => {
                xItemIndex = items.indexOf(d.x);
                return itemPlaceholders[xItemIndex];
            });

            return infoText[0];
        }

        public getBaselinePeriodEventsByMonth(events) {
            return events.map((monthlyTrend: any) => {
                return monthlyTrend.baseline.value;
            })

        }

        public getFocusPeriodEventsByMonth(events) {
            return events.map((monthlyTrend: any) => {
                if (!monthlyTrend.focus) {
                    return null;
                }
                else {
                    return monthlyTrend.focus.value;
                }
            })
        }

        public setPlaceholderText(text: string, shortTitle: string) {
            let w: any = window;

            let x_infotext = w.Plotly.d3.selectAll(".axistext").selectAll("text");

            //duplicate the x-axis info text
            let attr = x_infotext.node().attributes;
            let attr_length = attr.length;
            let node_name = x_infotext.property("nodeName");
            let parent = w.Plotly.d3.select(x_infotext.node().parentNode);
            let cloned = parent.append(node_name)
                .attr("id", "real_axistext");
            let j = 0;
            for (j = 0; j < attr_length; j += 1) {
                if (attr[j].nodeName !== "id") {
                    cloned.attr(attr[j].name, attr[j].value);
                }
            }

            let tooltipWidth = (text.length / shortTitle.length) * 0.8;

            //rescale the new info text
            w.Plotly.d3.selectAll(".axistext").selectAll("path").node().setAttribute("transform", `scale(${tooltipWidth},1)`);

            //assign the correct text to the next x-axis info text
            cloned.text(text);
            cloned.style("opacity", 1);
            //hide the old info text
            x_infotext.style("opacity", 0);
        }
        
    }

    angular.module('dg.lists')
        .service('chartService', ChartService);
}